module.exports = __webpack_public_path__ + "static/media/yellow_computer.b46feb11.svg";